<script>

    export let height;
    export let step;
    export let etype;

    let tooltipWidth;


    import {fade } from "svelte/transition";


   
    
  </script>

  <div
    class="tooltip"
    transition={{fade}}
    style="position: absolute; top: {0}px; left: {0}px; width: {235}px; height:95vh"
    bind:clientHeight={height} 
  > 
  
    <h1>Schooling Safely </h1>
    <h2><br>Exploring the air quality around 180 of Dublin's schools to empower decision makers.<br><br>
    </h2>
    {#if etype=='NO2'}
    <h2><br><b>NO2 yearly safe limits:</b></h2>
    <h2><b>EU</b>:40ug/m3</h2>
    <h2><b>WHO</b>:10ug/m3</h2>
    {/if}

    {#if etype=='PM25'}
    <br>
    <h2><b>PM25 yearly safe limits:</b></h2>
    
    <h2><b>EU</b>:20ug/m3</h2>
    <h2><b>WHO</b>:5ug/m3</h2>
    {/if}


  </div>
  
  <style>
    .tooltip {
      padding: 28px 12px;
      background: #4d5061;
      pointer-events: none;
      transition: all 500ms;

    }
    h1,
    h2,h3 {
      margin: 2px 2px 2px 2px;
      padding: 0;
      font-weight: 300;
      color: whitesmoke;
    }
    h1 {
      font-size: 1.6rem;
      font-weight: 600;
      margin-bottom: 6px;
      width: 100%;
    }
    h2 {
      font-size: .9rem;
      margin-left: 0px;
    }

    h3 {
        margin-left: 10px;
      font-size: .9rem;
    }


    .span2 {
      /* background: #dda0dd50; */
      font-size: 80%;
      text-transform: uppercase;

      margin-right: 0px;
      margin-top: 0px;
      margin-top: 10px;
      margin-bottom: 10px;

      padding-left: 2px;
      padding-right: 2px;
      padding-top: 4px;
      padding-bottom:4px;
      text-align: center;
      display: inline-block;
      vertical-align: bottom;
      border-radius: 5px;
      color: white;
      width:97%;
    }


    
    .span22 {
      /* background: #dda0dd50; */
      font-size: 80%;
      text-transform: uppercase;

      margin-right: 0px;
      margin-top: 0px;
      margin-top: 10px;
      margin-bottom: 10px;

      padding-left: 2px;
      padding-right: 2px;
      padding-top: 4px;
      padding-bottom:4px;
      text-align: center;
      display: inline-block;
      vertical-align: bottom;
      border-radius: 5px;
      color: white;
      width:97%;
    }



    .span3 {
      /* background: #dda0dd50; */
      font-size: 80%;
      height: 10px;
      width:10px;
      margin-bottom: 2px;
      margin-right: 5px;
      margin-left: 0px;
      text-align: center;
      display: inline-block;
      vertical-align: bottom;
      border-radius: 5px;
      color: white;
    }

    .span4 {
      /* background: #dda0dd50; */
      font-size: 80%;
      height: 10px;
      width:50px;
      margin-bottom: 2px;
      margin-right: 3px;
      margin-left: 0px;
      text-align: center;
      display: inline-block;
      vertical-align: bottom;
      border-radius: 5px;
      color: white;
    }
  </style>